import { createContext } from 'react'

export type Theme = 'dark' | 'light' | 'system'

export type ThemeProviderState = {
  theme: Theme
  setTheme: (theme: Theme) => void
  getResolvedTheme: () => Exclude<Theme, 'system'>
}

const initialState: ThemeProviderState = {
  theme: 'system',
  setTheme: () => null,
  getResolvedTheme: () => 'light',
}

export const ThemeProviderContext = createContext<ThemeProviderState | undefined>(initialState)
